<template>
    <a :href="disabled ? '' : link" @click="checkDisabled">
        <div class="card card-shadow">
            <div class="card-header py-2" :style="$bgColor(bgColor)">
                <slot></slot>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: "ContentCard",
    props: {
        bgColor: {
            type: String,
            default: "#ececec"
        },
        link: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        scheduleContent: {
            type: String,
            default: '',
        },
        content: {
            type: Object,
        }
    },
    methods: {
        showScheduleAlert() {
            if (this.content.lock_type === 'AVAILABLE') {
                return;
            } else if (this.content.lock_type === 'SCHEDULE') {
                return this.$notify({
                    type: 'warning',
                    message: this.scheduleContent,
                });
            } else {
                return this.$notify({
                    type: 'danger',
                    message: this.$t('common.blocked'),
                });
            }
        },
        checkDisabled(e) {
            if (this.disabled) {
                e.preventDefault();
                this.showScheduleAlert();
            }
        }
    }
};
</script>

<style scoped>
.card-shadow {
    -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11),
        0 1px 3px rgba(0, 0, 0, 0.08);
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.card .card-header:hover {
    background: #d8d8d8 !important;
}

.card .card-header {
    transition: background 0.3s !important;
    border: none;
}
</style>
